import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { GoalStrategyOverviewSection } from './GoalStrategyOverviewSection';

export const GoalStrategyOverviewSectionContainer = ({ relationship }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship);

  return (
    <DataContainer
      component={GoalStrategyOverviewSection}
      componentProps={{
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};

GoalStrategyOverviewSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
